<template>
  <div class="footer-locations">
    <div class="location">
      <p>EMPIRE TRAINING GROUNDS - BUENA PARK</p>
      <p>8575 1/2 Knott Avenue, Buena Park, CA 90620</p>
    </div>
    <div class="location">
      <p>Empire Training Grounds – Irvine</p>
      <p>5520 Trabuco Road, Irvine, CA 92620</p>
    </div>
  </div>
</template>
  
<script>
  export default {
    name: 'FooterLocations'
  }
</script>

<style scoped>
  .location {
    margin-bottom: 16px;
  }
</style>
  